import React from 'react'

import './quit.css'

const classNames = require('classnames');

export default class Quit extends React.Component<PropsType, StateType> {
  render() {
    const styles = classNames({
      'quit-fullScreen': true,
      'quit-btn': true,
      'brown': this.props.color === '#D5735B',
    })
    return (
      <div ref={this.props.refBtn} className={styles} style={{borderColor: this.props.color}}>
        <svg className="quit-svg" style={{'pointerEvents': 'none'}} width="9px" height="9px" viewBox="0 0 9 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <title>croix</title>
            <desc>Created with Sketch.</desc>
            <defs></defs>
            <g id="Interface" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="Desktop-HD-Copy-62" transform="translate(-317.000000, -476.000000)" stroke={this.props.color} strokeWidth="2.5">
                    <g id="Curseur-+" transform="translate(294.000000, 452.000000)">
                        <g id="croix" transform="translate(27.500000, 28.500000) rotate(-315.000000) translate(-27.500000, -28.500000) translate(23.000000, 24.000000)">
                            <path d="M4.5,0 L4.5,9" id="Stroke-3"></path>
                            <path d="M0,4.5 L9,4.5" id="Stroke-5"></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Photographer/Button/quit.jsx